const validationOrigin = "https://teksta.invalid";

export const parseSafeToPath = (toPathParam: string | null): string | null => {
  if (!toPathParam) return null;

  try {
    const candidate = new URL(toPathParam, validationOrigin);
    if (candidate.origin !== validationOrigin) return null;
    return candidate.pathname + candidate.search + candidate.hash;
  } catch {
    return null;
  }
};

export const resolveSafeToPath = ({
  defaultPath,
  toPathParam,
}: {
  defaultPath: string;
  toPathParam: string | null;
}) => {
  const fallback = parseSafeToPath(defaultPath) ?? "/app/dashboard/";
  return parseSafeToPath(toPathParam) ?? fallback;
};
